import React from "react";
import { useUI } from "../hooks/state";

const PromoHeader = ({ onButtonClick }) => {
  const { isMobile } = useUI();
  const text = isMobile
    ? ""
    : "Amplify Your Work, One Bubble at a Time. 🎉 Get 3 Months of Pro FREE With Code: POPTHREE";
  const buttonLabel = isMobile
    ? "Use 'POPTHREE' for 3 Months Pro FREE"
    : "Subscribe";

  return (
    <div
      className="promo-header"
      style={{
        width: "100%",
        backgroundColor: "#0d80b8",
        color: "white",
        padding: "12px 10px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        whiteSpace: isMobile ? "normal" : "nowrap",
        gap: "20px",
        fontWeight: "extra-bold",
        fontSize: "1.1rem",
      }}
    >
      <span>{text}</span>
      <button
        onClick={onButtonClick}
        style={{
          padding: "6px 14px",
          backgroundColor: "#7f63f1",
          color: "white",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer",
          fontWeight: "bold",
        }}
      >
        {buttonLabel}
      </button>
    </div>
  );
};

export default PromoHeader;
